import type ObservableOwaUserConfiguration from 'owa-service/lib/ObservableOwaUserConfiguration';
import { getStore } from '../store/store';

export default function getConnectedAccountUserConfiguration(
    userIdentity: string
): ObservableOwaUserConfiguration | undefined {
    return getStore().connectedAccountsUserConfigurationMap.get(userIdentity);
}
